import { chunk } from 'lodash';

import { PermissionResponse } from '~/redux/types/permissions';
import { pilot } from '~/services/serviceInstances';
import { Entity } from '~/types/Entity';
import { PilotId } from '~/types/PilotId';

const CHUNK_SIZE = 1000;

type GetEntityPermissionsParams = {
  userIds: PilotId[];
  entity: Entity<'document' | 'document_handler'>;
  enableChunkSpliting?: boolean;
};

/**
 * This method will work for entities of type 'document' and 'document_handler'
 */
export const checkUsersPermissions = async ({
  userIds,
  entity,
  enableChunkSpliting = false,
}: GetEntityPermissionsParams): Promise<PermissionResponse[]> => {
  const userIdsChunks = enableChunkSpliting
    ? chunk(userIds, CHUNK_SIZE)
    : [userIds];
  const permissionPromises = userIdsChunks.map((userIdsChunk) => {
    const data = {
      entityType: entity.type,
      entityId: entity.id,
      userIds: userIdsChunk,
    };
    return pilot.post(
      '/user/check-accessibility/',
      data,
    ) as Promise<PermissionResponse>;
  });

  return (await Promise.all(
    permissionPromises,
  )) as unknown as PermissionResponse[];
};
